import { get } from "@/utils/get";

import { MenuItem, TextField } from "@mui/material";
import PropTypes from "prop-types";

function InputSelect({
  fullWidth = true,
  getOptionLabel,
  hasEmpty,
  selects,
  selectValue = "value",
  value,
  error,
  emptyLabel = "None",
  onChange,
  ...props
}) {
  return (
    <>
      <TextField
        {...props}
        fullWidth={fullWidth}
        select
        onChange={(e) => onChange(props.id, e.target.value)}
        placeholder={props.name}
        value={selects?.length > 0 ? (value ?? "") : ""}
        error={!!get(props.name ?? props.id, error)}
        helperText={get(props.name ?? props.id, error)?.[0] || props.helperText}
      >
        {hasEmpty !== undefined && hasEmpty !== false && (
          <MenuItem value={hasEmpty} id={`${props.id}-null`}>
            <i>{emptyLabel}</i>
          </MenuItem>
        )}
        {Array.isArray(selects) &&
          selects.map((row, key) => {
            const isObject = typeof row === "object" && row !== null;

            return (
              <MenuItem
                key={key}
                value={isObject ? row[selectValue] : row}
                id={`${props.id}-${key}`}
                disabled={isObject ? row.disabled : false}
              >
                {getOptionLabel(row)}
              </MenuItem>
            );
          })}
        {selects.length === 0 && (hasEmpty === undefined || hasEmpty === false) && (
          <MenuItem disabled>No options available</MenuItem>
        )}
      </TextField>
    </>
  );
}

InputSelect.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  error: PropTypes.object,
  fullWidth: PropTypes.bool,
  helperText: PropTypes.string,
  label: PropTypes.string,
  emptyLabel: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  hasEmpty: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.number]),
  selects: PropTypes.array,
  getOptionLabel: PropTypes.func,
  selectValue: PropTypes.string,
  onChange: PropTypes.func,
};

export default InputSelect;
